<template>
    <k-panel class="border">
        <k-panel-header slot="header">
            <div slot="left">{{ $t("wallet") }}</div>
        </k-panel-header>
        <form autocomplete="off">
            <div class="mb-4">
                <k-select
                    class="mb-4"
                    id="account"
                    label="Account"
                    v-model="form.currencyCode"
                    :options="accountOptions"
                    value-key="value"
                    label-key="label"
                    :field-errors="validation.fieldErrors"/>
                <k-select
                    class="mb-4"
                    id="bankAccount"
                    label="Bank account"
                    v-model="form.bankAccountUuid"
                    :options="bankAccounts"
                    value-key="uuid"
                    label-key="accountNumber"
                    :field-errors="validation.fieldErrors"/>
                <label class="block text-gray-700 text-sm font-semibold mb-2"
                       for="amountToWithdraw">
                    {{ $t("amountToWithdraw") }}
                </label>
                <input v-model="form.amount"
                       class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       id="amountToWithdraw" type="text">
                <div v-if="fieldError('amount')"
                     class="text-red-500 text-xs italic">
                    {{ fieldError('amount') }}
                </div>
            </div>
            <div class="mt-6">
                <a-button type="primary" @click="submitWithdraw"
                          :disabled="form.amount <= 0.1">
                    {{ $t("withdraw") }}
                </a-button>
            </div>
        </form>
    </k-panel>
</template>

<script>

export default {
    components: {},
    props: {
        bankAccounts: {
            type: Array,
            required: true
        },
        accounts: {
            type: Array,
            required: true
        },
        validation: {
            type: Object
        }
    },
    data() {
        return {
            loading: false,
            form: {
                currencyCode: '',
                bankAccountUuid: '',
                amount: 0
            }
        };
    },
    methods: {
        async submitWithdraw() {
            this.$emit('withdraw', this.form);
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
        reset() {
            this.form = {
                bankAccountUuid: '',
                amount: 0
            }
        }
    },
    computed: {
        accountOptions() {
            return this.accounts.map(a => {
                return {
                    value: a.currencyCode,
                    label: a.currencyCode + ' ' + this.$options.filters.currencyFormat(a.balance, a.currencySymbol)
                }
            })
        }
    }
};
</script>


